"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppointmentEditorView = void 0;
var React = __importStar(require("react"));
var Actions = __importStar(require("./appointment-editor-actions"));
var styled_components_1 = __importDefault(require("styled-components"));
var use_debounce_1 = require("use-debounce");
var AppointmentEditorGrid = styled_components_1.default.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  list-style: none;\n  display: flex;\n  border: 0px;\n  margin: 24px 0 18px;\n  padding: 0;\n  gap: 16px;\n"], ["\n  list-style: none;\n  display: flex;\n  border: 0px;\n  margin: 24px 0 18px;\n  padding: 0;\n  gap: 16px;\n"])));
var TextInputLabel = styled_components_1.default.p(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: 0 0 0.2rem;\n  color: ", ";\n  font-size: 0.8rem;\n"], ["\n  margin: 0 0 0.2rem;\n  color: ", ";\n  font-size: 0.8rem;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.inputLabel;
});
var ModalHeader = styled_components_1.default.h2(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-size: 1rem;\n  margin: 6px 0 0;\n  color: ", ";\n  font-weight: normal;\n  border-bottom: 1px solid ", ";\n  padding: 0 0 2px 2px;\n"], ["\n  font-size: 1rem;\n  margin: 6px 0 0;\n  color: ", ";\n  font-weight: normal;\n  border-bottom: 1px solid ", ";\n  padding: 0 0 2px 2px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.inputLabel;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.border;
});
var NoteArea = styled_components_1.default.textarea(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
function AppointmentEditorView(_a) {
    var state = _a.state, dispatch = _a.dispatch;
    var userName = state.userName, startDate = state.startDate, startTime = state.startTime, endTime = state.endTime, endDate = state.endDate, notes = state.notes;
    var _b = __read(React.useState(notes), 2), appointmentNotes = _b[0], setAppointmentNotes = _b[1];
    var debounced = (0, use_debounce_1.useDebouncedCallback)(function (value) {
        dispatch(Actions.setNotes(value));
    }, 200);
    return (React.createElement("div", null,
        React.createElement(ModalHeader, null,
            userName,
            " - ",
            startDate),
        React.createElement(AppointmentEditorGrid, null,
            React.createElement("li", null,
                React.createElement(TextInputLabel, null, "Start"),
                React.createElement("input", { type: "text", maxLength: 5, size: 5, value: startTime, onChange: function (e) { return dispatch(Actions.setStartTime(e.target.value)); } })),
            React.createElement("li", null,
                React.createElement(TextInputLabel, null, "End"),
                React.createElement("input", { type: "text", maxLength: 5, size: 5, value: endTime, onChange: function (e) { return dispatch(Actions.setEndTime(e.target.value)); } })),
            React.createElement("li", null,
                React.createElement(TextInputLabel, null, "End Date"),
                React.createElement("input", { type: "text", maxLength: 10, size: 12, value: endDate, onChange: function (e) { return dispatch(Actions.setEndDate(e.target.value)); } }))),
        React.createElement(TextInputLabel, null, "Note"),
        React.createElement(NoteArea, { cols: 30, rows: 5, value: appointmentNotes, onChange: function (e) {
                setAppointmentNotes(e.target.value);
                debounced(e.target.value);
            } })));
}
exports.AppointmentEditorView = AppointmentEditorView;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=appointment-editor-view.js.map